export default __webpack_public_path__ + "static/media/Vazir-Bold.e17e5d28.woff2";